import { styled } from '@mui/system';
import { Box, Divider, TextField } from '@mui/material';
import { parseToNumberOrNull } from 'src/utils/numbers/parteToNumberOrNull';

export const FlexContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
});

export const FlexColumnContainer = styled(FlexContainer)({
  flexDirection: 'column',
});

export const CenteredContentContainer = styled(FlexContainer)({
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledDivider = styled(Divider)({
  margin: '16px 0',
});

export const ReadOnlyTextField = styled(TextField)({
  root: {
    '& .MuiInputBase-root': {
      '&:hover': {
        backgroundColor: 'inherit',
      },
      '&:focus': {
        backgroundColor: 'inherit',
        outline: 'none',
      },
    },
  },
  pointerEvents: 'none',
});

export const RoundedIconContainer = styled(Box)({
  borderRadius: '50%',
  padding: 10,
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
});

export const ScrollXWrapper = styled(FlexContainer)(({ theme, gap }) => {
  const parsedGap = parseToNumberOrNull(gap);

  return {
    width: '100%',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    gap: parsedGap ? theme.spacing(parsedGap) : 10,
    scrollBehavior: 'smooth',
    [theme.breakpoints.down('md')]: {
      WebkitOverflowScrolling: 'touch',
    },
    ['&::-webkit-scrollbar']: {
      display: 'none',
    },
  };
});

export const ScrollXItem = styled(Box)({
  flex: '0 0 auto',
});

export const RoundedFlexContainer = styled(FlexContainer)(({ theme }) => ({
  overflow: 'hidden',
  position: 'relative',
  borderRadius: `${theme.shape.borderRadius * 3.2}px`,
  border: `1px solid #f1f1f5`,
  width: '100%',
  maxWidth: '100%',
}));
